(() => {
  'use strict';

  const installPaymentMethodTabs = (root = document) => {
    const guide = root instanceof Element && root.matches('.pm-payment-guide')
      ? root
      : root.querySelector?.('.pm-payment-guide');

    if (!guide || guide.dataset.pmTabsInitialized === 'true') return;

    guide.dataset.pmTabsInitialized = 'true';

    const tabButtons = guide.querySelectorAll('.pm-tab-btn');
    const panels = guide.querySelectorAll('.pm-panel');

    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetId = this.getAttribute('data-target');
        const targetPanel = targetId ? document.getElementById(targetId) : null;

        if (!targetPanel || !guide.contains(targetPanel)) return;

        panels.forEach((panel) => {
          panel.classList.remove('pm-active');
          panel.setAttribute('aria-hidden', 'true');
        });

        tabButtons.forEach((tabButton) => {
          tabButton.classList.remove('pm-active');
          tabButton.setAttribute('aria-selected', 'false');
        });

        targetPanel.classList.add('pm-active');
        targetPanel.setAttribute('aria-hidden', 'false');

        this.classList.add('pm-active');
        this.setAttribute('aria-selected', 'true');
      });
    });
  };

  const boot = () => installPaymentMethodTabs(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    installPaymentMethodTabs(event.target);
  });
})();
